import BeachBoard from "./BeachBoard";
import WaiterPage from "./WaiterPage";
import OrdersPage from "./OrdersPage";
import { MapPin, ClipboardList, ReceiptText } from "lucide-react";

export default function WaiterHub({ view, setView }) {
  const Btn = ({ id, label, Icon }) => (
    <button data-testid={`waiter-view-${id}`} onClick={() => setView(id)}
      className={`flex h-10 flex-1 items-center justify-center gap-2 rounded-xl text-sm font-bold transition-colors sm:flex-none sm:px-6 ${view === id ? "bg-slate-900 text-white" : "bg-white text-slate-600 ring-1 ring-sand-300"}`}>
      <Icon size={16} /> {label}
    </button>
  );
  return (
    <div>
      <div className="mx-auto flex max-w-6xl gap-2 px-4 pt-4">
        <Btn id="location" label="Location" Icon={MapPin} />
        <Btn id="order" label="New order" Icon={ClipboardList} />
        <Btn id="orders" label="Orders" Icon={ReceiptText} />
      </div>
      {view === "location" ? <BeachBoard /> : view === "orders" ? <OrdersPage /> : <WaiterPage />}
    </div>
  );
}
